import { render, staticRenderFns } from "./inherit.vue?vue&type=template&id=65f6b326&scoped=true"
import script from "./inherit.vue?vue&type=script&lang=js"
export * from "./inherit.vue?vue&type=script&lang=js"
import style0 from "./inherit.vue?vue&type=style&index=0&id=65f6b326&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f6b326",
  null
  
)

export default component.exports